import { httpClient } from '@/src/@core/lib/httpClient'
import type { RestoUser } from '@/src/store/apps/resto365UserManagement'

function unwrapMePayload(payload: unknown): RestoUser {
  if (payload && typeof payload === 'object' && 'data' in payload) {
    const inner = (payload as { data: unknown }).data
    if (inner && typeof inner === 'object') {
      return inner as RestoUser
    }
  }

  return payload as RestoUser
}

export async function startRoleImpersonation(roleId: number): Promise<RestoUser> {
  const response = await httpClient.post('resto365-user/me/impersonate-role', { roleId })

  return unwrapMePayload(response.data)
}

export async function stopRoleImpersonation(): Promise<RestoUser> {
  const response = await httpClient.delete('resto365-user/me/impersonate-role')

  return unwrapMePayload(response.data)
}
